module.exports = __webpack_public_path__ + "img/1.449e460d.png";